import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { CHECKOUT_URL } from '../data/offer';
type CtaButtonProps = {
  label: string;
  sub?: string;
  tone?: 'dark' | 'light';
  id?: string;
};
export function CtaButton({
  label,
  sub,
  tone = 'light',
  id
}: CtaButtonProps) {
  return <div id={id} className="mx-auto mt-10 flex w-full max-w-xl flex-col items-center text-center sm:mt-12" data-id="element-10" data-mp="cl2ge9nhrpo4">
      <a href={CHECKOUT_URL} className="group flex w-full items-center justify-center gap-3 rounded-2xl bg-flame px-5 py-5 font-display text-[1.35rem] font-extrabold uppercase leading-tight tracking-wide text-white shadow-[0_8px_0_0_#B8330A] transition-[transform,box-shadow,background-color] duration-150 ease-out hover:-translate-y-0.5 hover:bg-[#FF6A33] focus:outline-none focus-visible:ring-4 focus-visible:ring-brand/60 active:translate-y-1.5 active:shadow-[0_2px_0_0_#B8330A] sm:px-8 sm:text-2xl" data-id="element-11" data-mp="qk251hb084ka">
        <span className="text-balance" data-id="element-12" data-mp="15arjcsjrhzsd">{label}</span>
        <ArrowRightIcon className="h-6 w-6 shrink-0 transition-transform duration-150 ease-out group-hover:translate-x-1" aria-hidden="true" data-id="element-13" data-mp="35xfm91cs6v7n" />
      </a>
      {sub && <p className={`mt-4 text-sm font-medium ${tone === 'dark' ? 'text-slate-300' : 'text-slate-600'}`} data-id="element-14" data-mp="3a0u47xka5lnq">{sub}</p>}
    </div>;
}